import { Link } from "@mui/material";
import { Link as RouterLink } from "@tanstack/react-router";
import { STRIPE_BILLING_URL } from "src/config";
import useGetUser from "src/hooks/useGetUser";
import { PATH_DASHBOARD } from "src/utils/paths";

export default function useGetMenuOptions() {
	const user = useGetUser();

	let menuOptions: any[] = [
		{
			to: PATH_DASHBOARD.profile,
			label: "account_popover.profile",
			component: RouterLink,
			icon: "mage:user"
		},
		{
			to: PATH_DASHBOARD.organization,
			label: "account_popover.org_settings",
			component: RouterLink,
			icon: "solar:settings-linear"
		},
		{
			href: STRIPE_BILLING_URL,
			label: "Facturación",
			target: "_blank",
			icon: "solar:bill-list-outline",
			component: Link
		}
	];

	if (user?.role !== "ROLE_ORG_ADMIN" && user?.role !== "ROLE_VUMI") {
		menuOptions = menuOptions.filter((option) => option.label !== "account_popover.org_settings");
	}

	return menuOptions;
}
